<template>
  <box-model title="科技服务信息">
    <template v-slot:content>
      <!-- <div class="c-item">
        {{ desc }}
      </div> -->
      <div class="scroll-text-container">
        <div class="scroll-text">
          {{ desc }}
        </div>
      </div>
    </template>
  </box-model>
</template>

<script>
export default {
  data() {
    return {
      desc: '1、种植时间（1）南方地区：春秋两熟的花生通常在每年的2月至3月中旬播种，长江流域春夏花生交作区适宜在3月至4月下旬种植。（2）北方地区：大花生区以及花生主产区多在4月下旬至5月上旬播种。2、种植方法（1）选种选择形状较整齐、颗粒比较饱满、没有破碎的荚果来作种，剥壳前晒2-3天，选择颜色鲜艳、粒大饱满且大小一致的种子播种。（2）整地施肥①选择排水良好、土层深厚肥沃、干时不板不散，湿时不粘不澥，黏沙土粒比例适中的沙壤土或轻壤土，土壤PH值为6.5-7。②整地前亩施农家肥2000kg，复合肥25kg，过磷酸钙25kg，然后耕翻土壤。③按2m宽作畦，播种6-7行，整地时开排水沟。（3）播种播种深度以3-4cm为宜，针对肥力较好的地块，中熟大粒花生亩播9000穴左右，中早熟中籽粒花生亩播约1万穴，播后覆土覆膜。3、管理技术（1）破膜放风①通常播种后10- 15天花生会陆续出苗，当子叶出土并张开时，或子叶未出土但可见真叶时，首先用手指或刀片在将幼苗处的地膜开一个十字形的小口，将幼苗引出膜，然后用细土封严开孔处，避免受到冻害。②在开孔放苗时，需要收看天气预报，当温度偏高时，破膜放苗不宜过晚，温度偏低时，不可立即破膜，防治温度过高烧苗和温度低冻苗。（2）化学除草①除草时间：在花生有1 - 3片复叶以及杂草2 - 5叶期除草，注意：选择2 - 3种除草剂进行复配才能达到防除效果。②除草配方：24 % 烯草酮50 - 60ml＋10 % 精奎禾灵60 - 80ml＋25 % 氟磺胺草醚80 - 100ml。（3）控旺技术①当花生生长过旺时，可采取2次控旺，第一次在花生开花后30天左右时进行，一般可增产10 - 15 %，第二次在花生谢花结荚初期，果针大量下扎时进行，其植株正常高度应保持在30 - 40cm。②在打控旺剂前需保持土壤湿润，土壤太旱易造成控旺剂不能完全吸收，提高对花生的抑制作用，造成减产。③一般采用烯效唑化控较好，可使用5 % 烯效唑30 - 40g兑水40 - 50kg进行喷雾，不建议使用多效唑。④注意事项：控旺时不能盲目增加用药量，应根据花生的长势来决定，严格按照说明使用；喷施后4 - 5个小时下雨，需补喷但是药量减半，重点喷在花生顶部的生长点，一喷而过，不能重喷以及漏喷。（4）防治病虫害①叶斑病用5 % 百菌清可湿性粉剂60 - 70kg倍液15天喷1次，共喷2次。②在锈病发病初期，用75 % 百菌清600倍液或25 % 粉锈宁500倍液全田喷雾。③茎腐病在苗期于齐苗后，用50 % 多菌灵1000倍液喷雾，在开花前再喷1次，亩用药液75 - 100kg。④根腐病在发病初期用50 % 多菌灵1000倍液全田喷雾。⑤在病毒病发病初期，喷洒10 % 病毒王可湿性粉剂500倍液，隔10 - 15天再喷1次，共喷2次。⑥在蚜虫发生期，每亩花生田均匀放20 - 30块涂有黄色机油的小黄色板，能诱杀有翅蚜虫，黄板每隔5 - 6天清虫1次并重刷油1次。二、花生怎么种才能高产 1、精施肥基肥采用一次性施肥方法，亩施腐熟家栏肥1000kg，花生专用复合肥50kg或复合肥75kg加过磷酸钙40 - 50kg、氯化钾10kg和硼砂1kg在犁翻前全层均匀施下。2、喷叶肥在结荚期后根外追肥，叶面喷施1 % 尿素溶液和2 - 3 % 过磷酸钙1 - 2次，也可亩用钼酸铵50g加水50kg喷施，10天后再喷1次。3、巧控苗 （1）花生结荚前期，当植株长至30cm时，及时叶面喷施70 - 100ml / Lppm水溶液，亩用液50 - 75L，能使花生植株矮化，防止徒长倒伏。（2）喷后若生长仍过于旺盛，可隔约10天再喷施1次，确保植株高度在30 - 40cm。4、花生踩秧（1）一般在7月下旬至8月中旬，选在晴天下午3时后，用脚将直立的花生秧踩倒，缩短果针与地面距离，促使果针早入土，达到控上促下，增果增收的目的。（2）在花生生长旺季，采取人工踩秧措施能控上促下，促使果针下扎，使单穴有效果数增加3 - 5个，产量提高20 %。5、巧施钙肥（1）在缺钙或缺硫的土壤中施用石膏，利于花生果壳的形成，提高结果率。（2）花生需钙量大，对钙的需求量多于磷接近于钾，尤其在结实期需钙量很大。6、巧施微肥在苗期与花期，亩用0.2 % 硼砂水溶液50kg叶面各喷洒1次，生长期亩用0.1 - 0.2 % 钼酸铵水溶液50kg叶面喷施1次，亩增产可达20 %。7、整株套圈（1）在盛花期压圈，将直径30 - 35cm的柳条编成圆圈后，压在三棵花生苗的中央部位，每穴花生各占1 / 3，使茎枝尽量匍匐于地面即可。（2）在花生盛花期进行整株压圈，能改善穴内株间的拥挤状况，可充分利用空间与光能，同时缩短果针与地面的距离，扩大结果范围，利于果针早扎土，多结果，结饱果。8、剪枝当花生开始长出花苞时，用剪刀剪掉病枝和无花向上枝，剪无花枝时，针对枝叶矮小枝条，每窝留3 - 4枝，枝叶高大则留2 - 3枝，可达到果实饱满且个大的目的。9、摘除主茎在盛花期10天后摘除主茎增产效果明显，亩可增产约15 %，过早或过迟摘除则效果不显著。',
    };
  },
  components: {
    'box-model': () => import('../../components/common/Model.vue'),
  },
};
</script>

<style scoped lang="less">
.c-item {
  height: 98px;
  overflow: auto;
  color: white;
}

::-webkit-scrollbar {
  width: 0;
}

.scroll-text-container {
  overflow: hidden;
  height: 98px;
  color: white;
  position: relative;
}

.scroll-text:hover {
  height: 98px;
  overflow: auto;
  color: white;
  animation-play-state: paused;
}

.scroll-text {
  animation: scroll-text 100s linear infinite;
}

@keyframes scroll-text {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-100%);
  }
}
</style>
